import { TechRadarLoaderResponse } from '@backstage/plugin-tech-radar';
import techRadarData from './tech-radar-data.json';

export const techRadarConfig: TechRadarLoaderResponse = {
  quadrants: [
    
    {
      id: 'platforms',
      name: 'Plataformas',
    },
    {
      id: 'data-management',
      name: 'Gestão de Dados',
    },
    {
        id: 'languages-and-frameworks',
        name: 'Linguagens e Frameworks',
    },
    {
      id: 'techniques',
      name: 'Ferramentas',
    },
  ],
  rings: [
    {
      id: 'adopt',
      name: 'Adotar',
      color: '#93c47d',
      description: 'Tecnologias que devem ser adotadas e utilizadas ativamente',
    },
    {
      id: 'trial',
      name: 'Experimentar',
      color: '#93d2c2',
      description: 'Tecnologias que devem ser experimentadas em projetos piloto',
    },
    {
      id: 'assess',
      name: 'Avaliar',
      color: '#fbdb84',
      description: 'Tecnologias que devem ser avaliadas para uso futuro',
    },
    {
      id: 'hold',
      name: 'Manter',
      color: '#efafa9',
      description: 'Tecnologias que devem ser mantidas mas não expandidas',
    },
  ],
  entries: techRadarData.entries.map(entry => ({
    ...entry,
    key: entry.id,
    timeline: entry.timeline.map(snapshot => ({
      ...snapshot,
      date: new Date(snapshot.date),
    })),
  })),
}; 